import React from 'react';
import { colors } from '../constants';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const checkmarkSvg = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width}
      height={props.height}
      viewBox={`0 0 20 20`}
      className={props.className}
    >
      <path
        fill={props.color}
        d="M4.732 9.435c-.377-.404-1.01-.427-1.414-.05-.404.376-.426 1.01-.05 1.413L7.22 15.04c.376.404 1.006.428 1.41.054l9.05-8.36c.404-.374.43-1.007.054-1.413-.374-.404-1.007-.43-1.413-.054L8.006 12.95 4.732 9.434z"
      />
    </svg>
  );
};

const Checkmark = styled(checkmarkSvg)`
  vertical-align: ${(props) => props.verticalAlign};
`;

Checkmark.displayName = 'Checkmark';

Checkmark.propTypes = {
  verticalAlign: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
};

Checkmark.defaultProps = {
  verticalAlign: 'baseline',
  width: 20,
  height: 20,
  color: colors.mediumGreenhouseGreen,
};

export default Checkmark;
